import axios from 'axios'
import { Loading, Message, MessageBox } from 'element-ui'
import router from '../router/index'
// http://192.168.5.47:8080  薛
// http://192.168.5.49:8080  杜
// http://192.168.5.54:8080  赵
// export const baseUrl = 'http://192.168.5.47:8080/jeecg-boot'

// export const baseImgUrl = 'http://192.168.5.47:8080/jeecg-boot/sys/common/static/'

export const baseUrl = window._CONFIG._URL.baseUrl 

export const baseImgUrl = window._CONFIG._URL.baseImgUrl

export const baseSchoolUrl = window._CONFIG._URL.baseSchoolUrl

// export const baseUrl = 'http://192.168.100.67:7029/jeecg-boot'

// export const baseImgUrl = 'http://192.168.100.67:7029/jeecg-boot/sys/common/static/'
axios.defaults.timeout = 10000 //  超时时间

var loadinginstace
let cancel, ajaxList

//请求拦截
axios.interceptors.request.use(
  config => {

    const token = window.localStorage.getItem('Authorization')
    config.headers['X-Access-Token'] = token && token
    loadinginstace = Loading.service({ fullscreen: true, spinner: 'load', background: 'rgba(0,0,0,0)' })
    const url = config.url
    if (ajaxList && ajaxList.length > 0 && ajaxList.filter(item => item == url).length > 1 && config.method != 'get') {
      cancel()
    }
    return config
  },
  error => {
    loadinginstace.close();
    Message.error({
      message: '网络不给力,请稍后再试'
    })
    return Promise.reject(error)
  }
)

//响应拦截
axios.interceptors.response.use(
  response => {
    loadinginstace.close();
    if (response.data.code === 500) {
      Message.error({
        showClose: true,
        message: response.data.message,
      })
      const url = response.config.url
      ajaxList = ajaxList && ajaxList.filter(item => item != url)
      return Promise.reject(new Error('error'))
    }
    if (response.data.code === 510 && response.data.result != '505') {
      //console.log("response",response);
      Message.error({
        showClose: true,
        message: response.data.message,
      })
      const url = response.config.url
      ajaxList = ajaxList && ajaxList.filter(item => item != url)
    }
    const url = response.config.url
    ajaxList = ajaxList && ajaxList.filter(item => item != url)
    return response
  },
  error => {
    loadinginstace.close();
    if (error.response) { //错误相应
      if (error.response.status === 500 && error.response.data.message == 'Token失效，请重新登录') {
        const szToken = window.localStorage.getItem('szToken')
        const jwToken = window.localStorage.getItem('jwToken')
        if (szToken || jwToken) {
          Message.error({
            showClose: true,
            message: '登录信息过期，请重新登录',
          })
          window.localStorage.clear()
          setTimeout(() => {
            window.location.reload()
          }, 500);
        } else {
          window.localStorage.removeItem('Authorization')
          router.replace({
            name: 'login',
            query: { redirect: router.currentRoute.fullPath } //登录后再跳回此页面时要做的配置
          })
        }
      } else {
        //loadinginstace.close();
        Message.error({
          showClose: true,
          message: '服务器数据错误',
        })
        return Promise.reject(error)
      }
    } else {
      Message.error({
        showClose: true,
        message: '网络不给力,请稍后再试',
      })
      return Promise.reject(error)
    }
  }
)


export const ajax = (url, data = {}, type = 'GET') => {
  const cancelToken = new axios.CancelToken(c => cancel = c)

  type = type.toUpperCase()
  url = baseUrl + url
  return new Promise(function (resolve, reject) {
    let promise
    if (type === 'GET' || type === 'DELETE') {
      let dataStr = ''
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      if (type === 'GET') {
        promise = axios.get(url, { cancelToken })
      } else if (type === 'DELETE') {
        promise = axios.delete(url, data, { cancelToken })
      }
    } else if (type === 'POST') {
      promise = axios.post(url, data, { cancelToken })
    } else if (type === 'PUT') {
      promise = axios.put(url, data, { cancelToken })
    }
    if (!ajaxList) {
      ajaxList = []
    }
    ajaxList.push(url)
    promise.then((res) => res && resolve(res.data)).catch(error => reject(error))
  })
}



// WEBPACK FOOTER //
// ./src/api/ajax.js